module.exports = __webpack_public_path__ + "static/media/anubhav.a58e60c5.png";